import { IconProps } from './types';

const CallingAgentIcon = (props: IconProps) => {
  const { width = 16, height = 16, fillColor = 'var(--charcoal-grey)' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M13.9941 13.6L14 13.834C14 14.3664 13.5365 14.8 12.9542 14.8H3.05174C2.47536 14.8 2.00594 14.3719 2.00594 13.834L2 13.6C2 11.421 3.37113 10.0544 5.58158 9.48904C7.12058 9.09935 8.87943 9.09935 10.4244 9.48904C10.4541 9.50002 10.4897 9.511 10.5254 9.51649C12.6883 10.0928 13.9941 11.4594 13.9941 13.6Z"
        stroke={fillColor}
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
      <path
        d="M8.00059 7.60029C9.32607 7.60029 10.4006 6.52578 10.4006 5.20029C10.4006 3.87481 9.32607 2.80029 8.00059 2.80029C6.6751 2.80029 5.60059 3.87481 5.60059 5.20029C5.60059 6.52578 6.6751 7.60029 8.00059 7.60029Z"
        stroke={fillColor}
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
      <path
        d="M4 5.2002C4 2.99106 5.79086 1.2002 8 1.2002C10.2091 1.2002 12 2.99106 12 5.2002C12 6.31915 11.5405 7.3308 10.8 8.05677"
        stroke={fillColor}
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.2002 4.4C3.2002 4.17909 3.37928 4 3.6002 4H4.0002V6.4H3.6002C3.37928 6.4 3.2002 6.22091 3.2002 6V4.4Z"
        stroke={fillColor}
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
      <path
        d="M12.7998 4.4C12.7998 4.17909 12.6207 4 12.3998 4H11.9998V6.4H12.3998C12.6207 6.4 12.7998 6.22091 12.7998 6V4.4Z"
        fill={fillColor}
        stroke={fillColor}
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CallingAgentIcon;
